"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LaExperienciaDeLaDraSoto() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const lineOne = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const lineTwo = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const ctas = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="4811" id="la-experiencia-de-la-dra-soto" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-multiply" style={{
      backgroundImage: "radial-gradient(var(--foreground) 1px, transparent 1px)",
      backgroundSize: "3px 3px"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute left-4 top-1/2 z-20 hidden -translate-y-1/2 lg:block">
        <span className="font-default text-[0.65rem] uppercase tracking-[0.3em] text-primary" style={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          MS Instituto Capilar — Excelencia (01 / 06)
        </span>
      </div>

      <div className="relative mx-auto grid min-h-screen max-w-[1500px] grid-cols-1 gap-8 px-6 pb-24 pt-28 sm:px-10 lg:grid-cols-12 lg:gap-10 lg:px-16 lg:pb-16 lg:pt-32">
        {}
        <div className="z-10 flex flex-col justify-center lg:col-span-5">
          {}
          <div ref={eyebrow.ref} className={`mb-8 transition-all duration-700 ease-out ${eyebrow.isVisible ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"}`}>
            
          </div>

          {}
          <h1 className="font-default font-medium leading-[0.95] tracking-tight text-foreground">
            <div className="overflow-hidden">
              <div ref={lineOne.ref} className="transition-all duration-1000 ease-out translate-y-0 !w-[450px] !text-[55px]" style={{
              fontSize: "clamp(3.5rem, 9vw, 8.5rem)"
            }}>Salud capilar personalizada</div>
            </div>
            <div className="overflow-hidden">
              
            </div>
          </h1>

          {}
          <p ref={paragraph.ref} className={`mt-10 max-w-[32ch] font-default text-lg leading-relaxed text-foreground/80 transition-all delay-300 duration-1000 ease-out sm:text-xl ${paragraph.isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
            La Dra. María del Carmen Soto combina rigor científico y sensibilidad estética para devolverte la confianza en tu imagen, con resultados naturales y duraderos.
          </p>

          {}
          <div ref={ctas.ref} className={`mt-12 flex flex-wrap items-center gap-6 transition-all delay-500 duration-1000 ease-out ${ctas.isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
            <Button asChild size="lg" className="group h-12 bg-primary px-7 font-default text-base font-medium text-white shadow-md transition-all hover:bg-secondary">
              <Link href="https://​https://msinstitutocapilar.com/contacto/" newTab>
                Solicitar Consulta
                <ArrowRight className="ml-1 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>

            <Link className="group inline-flex items-center gap-1 font-default text-base italic text-foreground underline-offset-4 transition-all hover:underline" href="https://​https://msinstitutocapilar.com/cirugia-capilar/" newTab>Ver Cirugía Capilar<span className="inline-block transition-transform group-hover:translate-x-1" data-ast-id="f:/src/pages/DrSoto/sections/LaExperienciaDeLaDraSoto.tsx|sig:2e2eqx" data-ast-start="4990" data-ast-end="5108">→</span></Link>
          </div>
        </div>

        {}
        <div className="relative lg:col-span-7">
          <div ref={image.ref} className={`relative h-[60vh] w-full overflow-hidden rounded-lg shadow-lg transition-all duration-[1400ms] ease-out lg:absolute lg:inset-y-0 lg:right-[-4rem] lg:h-full lg:w-[calc(100%+4rem)] ${image.isVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_clinic.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_clinic.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_clinic.png-wvc-sizes" alt="La Dra. María del Carmen Soto en su consulta capilar" loading="eager" decoding="async" className="object-cover !w-[800px] !h-[500px]" style={{
            filter: "saturate(0.9) contrast(1.05) brightness(1.0)"
          }} src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/Eliminar-letras-azules-y-logo-1-scaled.png" />
            {}
            <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
            backgroundImage: "radial-gradient(var(--foreground) 1px, transparent 1px)",
            backgroundSize: "2px 2px"
          }} aria-hidden="true" />

            {}
            <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
              <span className="font-default text-[0.65rem] uppercase tracking-[0.25em] text-white/90">MEDICINA CAPILAR DE VANGUARDIA</span>
              <span className="font-default text-[0.65rem] uppercase tracking-[0.25em] text-white/90"></span>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-20 flex -translate-x-1/2 flex-col items-center gap-3">
        
        
      </div>

      <style>{`
        @keyframes scroll-cue {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}